export class Profissionais {
  id?: number;
  cnsProfissionalSaude?: string;
  codigoOcupacao?: string;
  cpf?: string;
  nomeProfissionalSaude?: string;
  nuCrm?: string;
  ocupacao?: string;
  ufCrm?: string;

  constructor(data?) {
    if (data) {
      this.id = data.id;
      this.cnsProfissionalSaude = data.cnsProfissionalSaude;
      this.codigoOcupacao = data.codigoOcupacao;
      this.cpf = data.cpf;
      this.nomeProfissionalSaude = data.nomeProfissionalSaude;
      this.nuCrm = data.nuCrm;
      this.ocupacao = data.ocupacao;
      this.ufCrm = data.ufCrm;
    }
  }

}